export const CALENDAR = "https://calendar.app.google/Fnb7BzNRP6Bzyc1u7";
export const EMAIL = "sandeepsirodia@gmail.com";
export const LINKEDIN = "https://www.linkedin.com/in/sandeepsirodia/";
export const RESUME =
  "https://customer-assets-agu9un31.emergentagent.net/job_2326a09c-f018-4ff3-aa99-d4df7ea6f3dc/artifacts/dgjyahft_Sandeep%20Resume%20New%20Version.pdf";
export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const HERO_LINES = [
  { text: "I turn messy" },
  { text: "workflows into" },
  { em: "shipped", tail: " AI products." },
];

export const TERMINAL_LINES = [
  { text: "$ whoami", tone: "cmd" },
  { text: "sandeep — forward deployed engineer", tone: "out" },
  { text: '$ ship --from "manual, slow, stuck"', tone: "cmd" },
  { text: "▸ understand the workflow", tone: "step" },
  { text: "▸ find the AI leverage", tone: "step" },
  { text: "▸ deploy to production", tone: "step" },
  { text: "✓ outcome: less busywork, more momentum", tone: "ok" },
];

export const MARQUEE_ITEMS = [
  "Forward Deployed Engineering",
  "AI Agents",
  "RAG Pipelines",
  "LLM Evals",
  "React · Next.js",
  "Django · Python",
  "0 → 1 Products",
  "Production Automation",
];

export const WINS = [
  { value: 50, suffix: "×", label: "scale enabled", detail: "Lean-headcount AI operations for a US startup" },
  { value: 98, suffix: "%", label: "LLM accuracy", detail: "Up from 65% with evals + human review" },
  { value: 10, suffix: "k+", label: "URLs / day", detail: "Async crawl infrastructure built on AWS" },
  { value: 20, suffix: "%", label: "conversion lift", detail: "Onboarding redesign at Nanonets" },
];

export const SERVICES = [
  {
    icon: "01",
    title: "AI systems that ship",
    copy: "Agents, RAG, evals and automation — connected to the workflows your team already runs. Not a demo that dies in month three: systems with monitoring, cost caps and a human in the loop where it matters.",
    capabilities: ["Agents & tool use", "RAG & retrieval", "Evals & monitoring", "Cost & latency caps"],
  },
  {
    icon: "02",
    title: "Full-stack, end to end",
    copy: "From a fuzzy product brief to a resilient React interface, backend and cloud infrastructure.",
  },
  {
    icon: "03",
    title: "Senior frontend leverage",
    copy: "Untangle the codebase, speed up the product and give your team an architecture they can trust.",
  },
];

export const EXPERIENCES = [
  { years: "2026 — now", role: "Forward Deployed Engineer · Consulting", company: "Self-employed", copy: "Embedding with fast-moving startups across the US and UK to turn “we need AI to do X” into production automation — in days, not quarters.", tags: ["AI Agents", "React", "FDE"] },
  { years: "2024 — 2026", role: "Co-Founder & CTO", company: "Consumable AI", copy: "Built and scaled an AI-powered SEO/AEO platform for 10+ enterprise clients, leading a four-person engineering team end to end.", tags: ["RAG", "Django", "AWS Lambda"] },
  { years: "2022 — 2024", role: "Senior Software Engineer", company: "Nanonets", copy: "Architected a high-performance React frontend for an Accel-backed document AI platform serving Fortune 500 companies.", tags: ["React", "OpenAI", "TanStack Query"] },
  { years: "2018 — 2022", role: "Frontend Lead → Founding Engineer", company: "Prodigal", copy: "The sole frontend architect across 9+ codebases, building a real-time desktop product used by enterprise collection teams.", tags: ["Electron", "WebSockets", "Cypress"] },
  { years: "2017 — 2018", role: "Frontend Web Developer · Intern", company: "Hotstar", copy: "Built advertiser tools and reporting dashboards for India’s largest streaming platform.", tags: ["React", "RBAC", "Data Viz"] },
];

export const STACK_ROWS = [
  { area: "Frontend", items: "React · Next.js · Electron" },
  { area: "Backend", items: "Python · Django · Node.js · Golang" },
  { area: "AI", items: "LangChain · Agno · RAG · LLM Evals" },
  { area: "Infra & Data", items: "AWS · Docker · Postgres · Redis · MongoDB" },
];

export const FAQ_ITEMS = [
  ["What kind of engagement works best?", "Usually a focused sprint or an embedded engagement: I join the team, understand the workflow, and own a meaningful path from problem to production."],
  ["How quickly can we start?", "For the right problem, I can usually start within one to two weeks. A first call is enough to map the shape, urgency, and next useful step."],
  ["What does the first call cover?", "We’ll unpack what is stuck, who feels the pain, what has already been tried, and what a high-leverage first milestone looks like."],
  ["Can you help us find the right AI opportunity?", "Yes. We start with the workflow, not the model: identify repetitive decisions, define guardrails, then prototype and measure before scaling."],
];
